export type Layout = null | "confluence" | "jira" | "jira-product-discovery";

export const TIMEOUT = 600000;

export function getLayout(products: string[]): Layout {
    if (products.some((product) => product.includes("confluence"))) {
        return "confluence";
    }
    if (
        products.some((product) => product.includes("jira-product-discovery"))
    ) {
        return "jira-product-discovery";
    }
    return null;
}
